import { OtpChannel } from './otp.types';

export const AUTH_TYPES = {
  PASSWORD: 'Password',
  OTP: 'OTP'
} as const;

export const SIGNUP_TYPES = {
  OPEN: 'Open',
  CLOSED: 'Closed'
} as const;

export const FIELD_TYPES = {
  EMAIL: 'email',
  CPF: 'cpf',
  PASSWORD: 'password',
  TEXT: 'text'
} as const;

export type AuthenticationType = typeof AUTH_TYPES[keyof typeof AUTH_TYPES];
export type SignupType = typeof SIGNUP_TYPES[keyof typeof SIGNUP_TYPES];
export type FieldType = typeof FIELD_TYPES[keyof typeof FIELD_TYPES];

// Tipagem para regras de validação de campos
export interface FieldRule {
  required?: boolean;
  min?: number;
  max?: number;
  pattern?: string;
  message: string;
}

// Tipagem para campos de formulário
export interface FormField {
  type: FieldType;
  name: string;
  label: string;
  placeholder?: string;
  tooltip?: string;
  mask?: string;
  options: any[];
  rules: FieldRule[];
}

// Tipagem para seções do formulário
export interface FormSection {
  verificationOption?: string;
  isMixedCampaign?: boolean;
  makeRequiredFieldsFlexible?: boolean;
  option?: string;
  formFields: FormField[];
}

// Tipagem para termos
export interface Term {
  id: string;
  title: string;
  fileId: string;
  contentUrl: string;
  startDate: string;
  endDate: string;
}

// Tipagem principal do Schema
export interface Schema {
  id: string;
  tenantId: string;
  signupType: SignupType;
  authenticationType: AuthenticationType;
  invitationType?: string;
  otpRequestChannelTypes?: OtpChannel[];
  username?: FormSection;
  personal?: FormSection;
  address?: FormSection;
  contact?: FormSection;
  additionalInfo?: FormSection;
  terms?: Term[];
  createdDate: string;
  updatedDate: string;
}
